import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { Link } from 'react-router-dom';

export default function CookiePage() {
  const SITE_URL = __VITE_SITE_URL__;

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-24 pb-16">
        <div className="max-w-3xl mx-auto px-4 md:px-6">
          <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-2">Cookie Policy</h1>
          <p className="text-foreground-400 text-sm mb-10">Ultimo aggiornamento: Luglio 2026</p>
          <div className="prose prose-sm text-foreground-600 space-y-6">
            <section>
              <h2 className="font-heading text-xl font-bold text-foreground-800 mb-3">Cosa sono i Cookie</h2>
              <p>I cookie sono piccoli file di testo che i siti web salvano sul tuo dispositivo durante la navigazione. Servono a ricordare le tue preferenze e a migliorare l&apos;esperienza di navigazione.</p>
            </section>
            <section>
              <h2 className="font-heading text-xl font-bold text-foreground-800 mb-3">Cookie Utilizzati</h2>
              <p>itaobuyspread.lol utilizza esclusivamente cookie tecnici di sessione necessari al corretto funzionamento del sito. Non vengono utilizzati cookie di profilazione, pubblicitari o di terze parti per il tracciamento.</p>
            </section>
            <section>
              <h2 className="font-heading text-xl font-bold text-foreground-800 mb-3">Gestione dei Cookie</h2>
              <p>Puoi disabilitare i cookie modificando le impostazioni del tuo browser. Ti informiamo che la disabilitazione dei cookie tecnici potrebbe influire sul corretto funzionamento del sito.</p>
            </section>
          </div>
          <Link to="/" className="inline-flex items-center gap-2 mt-10 text-sm text-primary-500 hover:text-primary-600 transition-colors">
            <i className="ri-arrow-left-line"></i> Torna alla Home
          </Link>
        </div>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: 'Cookie Policy — Itaobuy Spreadsheet Italia',
            description: 'Cookie Policy di itaobuyspread.lol. Informazioni sui cookie utilizzati, la loro gestione e le preferenze di navigazione.',
            inLanguage: 'it',
            isPartOf: {
              '@type': 'WebSite',
              name: 'Itaobuy Spreadsheet Italia',
              url: SITE_URL,
            },
          }),
        }}
      />
    </div>
  );
}